// 決定的カラーのアバターユーティリティ（Circleback風）
export const AVATAR_PALETTE = ['#4f6df5', '#0ea5e9', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6']

export function avatarHash(key: string): number {
  let h = 0
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) | 0
  return Math.abs(h)
}

export function avatarColor(key: string): string {
  return AVATAR_PALETTE[avatarHash(key) % AVATAR_PALETTE.length]
}

/** 名前 or メールアドレスから頭文字を返す */
export function avatarInitial(value: string): string {
  const base = (value.includes('@') ? value.split('@')[0] : value).trim()
  return (base.charAt(0) || '?').toUpperCase()
}
